import { useState, useEffect, useCallback, useRef } from 'react';
import { AuthenticationContext } from '../Contexts';
import { buscar } from '../Utils/Buscar';
import {USUARIO_LOGIN_COMPLETO} from "../Utils";
export function AuthenticationProvider({ children }) {
    const [user, setUser] = useState(undefined);
    const consultaActualId = useRef();

    useEffect(() => {
        setTimeout(() => {
            refreshUserLogin();
        }, 500);
    }, []);

    const onRefreshUsuarioLoginError = (error) => {
        console.dev("onRefreshUsuarioLoginError:", error);
        setCurrentSession(null);
    };

    const refreshUserLogin = () => {
        const consultaId = Math.random();
        consultaActualId.current = consultaId;
        const url = USUARIO_LOGIN_COMPLETO
        try {
            buscar(url, {}).then((data) => {
                if (consultaId === consultaActualId.current) {
                    if(data) {
                        setCurrentSession(data);
                    }
                }
            }).catch((e) => {
                onRefreshUsuarioLoginError(e);

            })
        }catch (e) {
            onRefreshUsuarioLoginError(e);
        }
    };

    const setCurrentSession = useCallback(
        (data) => {
            setUser(data ?? null);
        },
        [user]
    );

    const TIENE_PERMISO = (permiso) => {
        return user?.Funciones?.some((f) => f === permiso);
    };

    return (
        <AuthenticationContext.Provider
            value={{ user, TIENE_PERMISO }}
        >
            {children}
        </AuthenticationContext.Provider>
    );
}
